module.exports = __webpack_public_path__ + "static/media/big-bass-bonanza.008133f9.gif";